<!--
 * @Author: your name
 * @Date: 2022-06-13 09
-->
<template>
  <div>
    <!-- 是首页 -->
    <div class="head-row">
      <div class="head-details" >
        <div class="right-img" @click="toHome"><img src="../assets/icon/home/voge.png" alt=""></div>
        <div class="left-img" @click="dropDown" v-if="Change == false"><img src="../assets/icon/home/tab.png" alt=""></div>
        <div class="left-img" @click="dropDown" v-else><img src="../assets/icon/heads/shang.png" alt=""></div>
      </div>
    </div>
    <!-- 下拉 -->
    <div class="drop-down" :class="{'auto-height':Change}">
      <!-- 搜索 -->
      <div class="sort">
        <div class="head-icon">
          <img src="@/assets/icon/heads/search-icon.png" alt="">
          <van-search v-model="searchVal" placeholder="请输入搜索车型" @search="onSearch"/>
          <!-- <img src="@/assets/icon/heads/phone-icon.png" alt=""> -->
        </div>
        <!-- <div class="language">
          <div class="zh" @click="languageChange('zh')" :class="language == 'zh' ? 'language-active' : ''">ZH</div>
          <div>/</div>
          <div class="en" @click="languageChange('en')" :class="language == 'en' ? 'language-active' : ''">EN</div>
        </div> -->
      </div>
      <!-- 导航 -->
      <div class="content">
        <div class="home" @click="toHome">
          <div class="title"> 首页 </div>
          <div class="heng"></div>
        </div>
        <!-- 品牌故事 -->
        <div class="story">
          <div class="title"> 品牌故事 </div>
          <div class="symbol" @click="symbol(1)">
            <div v-if="storyChange == false">+</div>
            <div v-else>-</div>
          </div>
          <div class="children-box" :class="{'auto-height':storyChange}">
            <a class="text" @click="topath(item.path)" v-for="(item,idx) in childrenList[0]" :key="idx">
              <p class="text">{{item.title}}</p>
            </a>
          </div>
          <div class="heng"></div>
        </div>
        <!-- 产品世界 -->
        <div class="products" @click="toProductCenter">
          <div class="title"> 产品世界 </div>
          <div class="heng"></div>
        </div>
        <!-- 新闻潮汛 -->
        <div class="news">
          <div class="title"> 新闻潮汛 </div>
          <div class="symbol" v-if="newsChange == false" @click="symbol(2)">+</div>
          <div class="symbol" v-else @click="symbol(2)">-</div>
          <div class="children-box" :class="{'auto-height':newsChange}">
            <p class="text" @click="topath(item.path)" v-for="(item,idx) in childrenList[1]" :key="idx">{{item.title}}</p>
          </div>
          <div class="heng"></div>
        </div>
        <!-- 无极服务 -->
        <div class="serve">
          <div class="title"> 无极服务 </div>
          <div class="symbol" v-if="serveChange == false" @click="symbol(3)">+</div>
          <div class="symbol" v-else @click="symbol(3)">-</div>
          <div class="children-box" :class="{'auto-height':serveChange}">
            <p class="text" @click="topath(item.path)" v-for="(item,idx) in childrenList[2]" :key="idx">{{item.title}}</p>
          </div>
          <div class="heng"></div>
        </div>
        <!-- 预约品鉴 -->
        <div class="appointment">
          <div class="title"> 预约品鉴 </div>
          <div class="symbol" v-if="atChange == false" @click="symbol(4)">+</div>
          <div class="symbol" v-else @click="symbol(4)">-</div>
          <div class="children-box" :class="{'auto-height':atChange}">
            <p class="text" @click="topath(item.path)" v-for="(item,idx) in childrenList[3]" :key="idx">{{item.title}}</p>
          </div>
          <div class="heng"></div>
        </div>
      </div>
    </div>
    <!-- 悬浮窗 -->
    <div class="float-window">
      <div class="flot-box" @click="showPopup('cxws')">
        <img src="@/assets/icon/heads/last-act-ewm.png" alt="">
        <!-- <img v-else="mouseAct" src="@/assets/act-ewm.png" alt=""> -->
        <p class="text">无极机车</p>
      </div>
      <van-popup v-model="show">
        <div v-if="showVal == 'cxws'" class="float-details">
          <div class="content">
            <img src="@/assets/icon/heads/vgjc.png" alt="">
            <p>扫码下载</p>
          </div>
        </div>
        <div v-if="showVal == 'ggx'" class="float-details">
          <div class="content">
            <img src="@/assets/icon/heads/ggx.png" alt="">
            <p>扫码下载</p>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
import { searchApi } from "@/api/api";
import { Collapse, CollapseItem, Search, Popup, Toast } from 'vant';
export default {
  components:{
    [Collapse.name]:Collapse,
    [CollapseItem.name]:CollapseItem,
    [Search.name]:Search,
    [Popup.name]:Popup,
  },
  data(){
    return{
      show:false,
      showVal:null,
      Change:false,
      storyChange:false,
      newsChange:false,
      serveChange:false,
      atChange:false,
      language: 'zh',
      activeName: '1',
      searchVal:'',
      childrenList:[
        [ {title:'品牌文化',path:'/brandCulture'}, {title:'匠心故事',path:'/originalityStory'}, {title:'品牌历程',path:'/brandCulture#course'} ],
        [ {title:'无极动态',path:'/dynamic'}, {title:'最新活动',path:'/latestActivity'}, {title:'媒体测评',path:'/evaluation'} ],
        [ {title:'保修范围',path:'/warranty'},{title:'服务反馈',path:'/feedback'}, {title:'保养指南',path:'/maintain'}, {title:'摩旅服务',path:'/travelService'} ],
        [ {title:'预约试驾',path:'/subscribe'}, {title:'门店查询',path:'/shop'}, {title:'片区招商',path:'/attractInvestment'} ],
      ]
    }
  },
  methods:{
    showPopup(val){
      this.show = true
      this.showVal = val
    },
    languageChange(name) {
      this.language = name
    },
    // 搜索
    onSearch(val){
      const params = {
        m:'Mobile',
        c:'MajorProduct',
        a:'get_product_id_list',
        pro_name:val
      }
      searchApi(params).then(({data})=>{
        if (data.datas.list.length==0) {
          Toast('请输入正确车型')
        }else{
          this.$router.push({
            path:'/particulars',
            query:{id:data.datas.list[0].lead_product_id}
          })
          this.Change = false
        }
      })

    },
    // 跳转
    topath(path){
      this.$router.push(path)
      this.Change = false
    },
    // 子路由，展开/收缩，手风琴效果
    symbol(val){
      switch (val) {
        case 1:
          this.storyChange = !this.storyChange
          if (this.newsChange == true || this.serveChange == true || this.atChange == true) {
            this.newsChange = false
            this.serveChange = false
            this.atChange = false
          }
          break;
        case 2:
          this.newsChange = !this.newsChange
          if (this.storyChange == true || this.serveChange == true || this.atChange == true) {
            this.storyChange = false
            this.serveChange = false
            this.atChange = false
          }
          break;
        case 3:
          this.serveChange = !this.serveChange
          if (this.storyChange == true || this.newsChange == true || this.atChange == true) {
            this.storyChange = false
            this.newsChange = false
            this.atChange = false
          }
          break;
        case 4:
          this.atChange = !this.atChange
          if (this.storyChange == true || this.newsChange == true || this.serveChange == true) {
            this.storyChange = false
            this.newsChange = false
            this.serveChange = false
          }
          break;
        default:
          break;
      }

    },
    // 下拉，展开/收缩
    dropDown(){
      this.Change = !this.Change
    },
    // 到 - 首页
    toHome(){
      this.$router.push('/home')
      this.Change = false
    },
    // 到 - 产品世界
    toProductCenter(){
      this.$router.push('/productCenter')
      this.Change = false
    }
  }
}
</script>
<style lang="scss" scoped>
.head-row{
  width: 100%;
  height: 14.6667vw;
  background: #FBCC0A;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  .head-details{
    display: flex;
    justify-content: space-between;
    width: 90.9333vw;
    margin: 0 auto;
    height: 100%;
    align-items: center;
    .right-img{
      display: flex;
      align-content: center;
      img{
        width: 8vw;
        height: 8vw;
      }
    }
    .left-img{
      display: flex;
      align-content: center;
      img{
        width: 8vw;
        height: 8vw;
      }
    }
  }

}
.wrongHome{
  background: #000000 !important;
}
.drop-down{
  position: fixed;
  top: 14.6667vw;
  width: 100%;
  height: 0vh;
  z-index: 999;
  overflow: hidden;
  background: url("../assets/icon/heads/hone-content.jpg") no-repeat center;
  background-size: 100% 100%;
  transition: 0.5s;
  &.auto-height{
    height:100vh;
  }
  .sort{
    width: 90%;
    height: 80px;
    border-bottom: solid 1px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .head-icon{
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img{
        width: 40px;
        height: 40px;
        margin-right: 20px;
      }
      .van-search{
        padding: 0;
        width: 100%;
        .van-search__content{
          padding-left: 0;
        }
      }
      /deep/.van-field__left-icon{
        display: none;
        position: absolute;
      }
      .van-search{
        background-color: transparent;
      }
      .van-search__content{
        background-color: transparent;
      }
    }
    .language {
      margin-left: 30px;
      display: flex;
      justify-content: center;
      font-weight: bold;
      color: #000000;
      font-size: 40px;
      cursor: pointer;
      .language-active {
          color: #FBCC0A;
      }
    }
  }
  .content{
    width: 100%;
    text-align: center;
    margin-top: 20px;
    .title{
      font-size: 30px;
      margin-top: 30px;
    }
    .symbol{
      // margin-bottom: 10px;
      font-size: 50px;
      height: 40px;
    }
    .children-box{
      height: 0;
      overflow: hidden;
      transition: 1s;
      &.auto-height{
        height: auto;
      }
      .text{
        font-size: 30px;
        margin: 30px 0;
        color: #939393;
      }
    }
    .heng{
      width: 30%;
      height: 1px;
      background: #939393;
      margin: 25px auto 0;
    }
  }
}
.float-window{
  z-index: 999;
  position: fixed;
  top: 40vh;
  right: 0;
  height: 230px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .content{
    padding: 20px;
    p {
      margin-top: 10px;
    }
  }
  .van-popup{
    border-radius: 24px;
    background-color: #facc0a;
  }
  .flot-box{
    padding: 10px 10px;
    background-color: #0000006e;
    display: flex;
    flex-direction: column;
    align-items: center;
    .text{
      margin-top: 10px;
      font-size: 16px;
      color: white;
    }
    img{
      width: 50px;
      height: 50px;
    }
  }
}
.float-details{
    font-size: .4rem;
    text-align: center;
}
</style>
